// demo 模块
const Index = () => import('@/views/demo/Index')
const Test = () => import('@/views/demo/Test')
export default [
  {
    path: '/demo/index',
    component: Index
  },
  {
    path: '/demo/test',
    component: Test,
    meta: {
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/demo.js